/**
 * Filter-pill row used by the Detailed Findings tab. "All" is always first;
 * subsequent pills correspond to each visible category (same order as the
 * Category Accordion). Controlled — parent owns the active id + onChange.
 */
export function FilterPillBar({ categories, activeId, onChange }) {
  const cats = (categories || []).filter((c) => !c.hidden);
  return (
    <div className="filter-row" role="tablist" aria-label="Category filter">
      <button
        type="button"
        role="tab"
        aria-selected={activeId === 'all'}
        className={`filter-pill ${activeId === 'all' ? 'active' : 'inactive'}`}
        onClick={() => onChange('all')}
      >
        All
      </button>
      {cats.map((cat) => {
        const isActive = String(cat.id) === String(activeId);
        return (
          <button
            key={cat.id}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`filter-pill ${isActive ? 'active' : 'inactive'}`}
            onClick={() => onChange(String(cat.id))}
          >
            {cat.name}
          </button>
        );
      })}
    </div>
  );
}
